import { render, staticRenderFns } from "./StarPartner.vue?vue&type=template&id=3d5f6e8c&scoped=true&"
import script from "./StarPartner.vue?vue&type=script&lang=js&"
export * from "./StarPartner.vue?vue&type=script&lang=js&"
import style0 from "./StarPartner.vue?vue&type=style&index=0&id=3d5f6e8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5f6e8c",
  null
  
)

export default component.exports